import { makeAutoObservable } from "mobx";

const DEFAULT_PAGE_SIZE = 10;
const VALID_SORT_BY = new Set(["code", "category", "title", "target", "cell"]);
const VALID_SORT_DIR = new Set(["asc", "desc"]);
const DEFAULT_SORT = { by: "category", key: "", direction: "asc" };

class DashboardEsgDataTableStore {
  rows = [];
  total = 0;
  totalPages = 0;

  page = 1;
  pageSize = DEFAULT_PAGE_SIZE;

  sort = { ...DEFAULT_SORT };

  loading = false;
  hasLoadedOnce = false;
  requestSeq = 0;

  constructor() {
    makeAutoObservable(this);
  }

  nextRequestSeq = () => {
    this.requestSeq += 1;
    return this.requestSeq;
  };

  isStaleSeq = (seq) => seq !== this.requestSeq;

  setSort = ({ by, key, direction }) => {
    const nextBy = VALID_SORT_BY.has(by) ? by : DEFAULT_SORT.by;
    const nextDir = VALID_SORT_DIR.has(direction)
      ? direction
      : DEFAULT_SORT.direction;
    const nextKey = nextBy === "cell" ? String(key ?? "") : "";
    this.sort = { by: nextBy, key: nextKey, direction: nextDir };
    this.page = 1;
  };

  toggleSortDirection = () => {
    this.sort = {
      ...this.sort,
      direction: this.sort.direction === "asc" ? "desc" : "asc",
    };
    this.page = 1;
  };

  setResult = ({ rows, total, totalPages, page, pageSize }) => {
    this.rows = Array.isArray(rows) ? rows : [];
    this.total = Number(total ?? 0);
    this.totalPages = Number(totalPages ?? 0);
    this.page = Number(page ?? this.page);
    this.pageSize = Number(pageSize ?? this.pageSize);
    this.hasLoadedOnce = true;
  };

  setLoading = (value) => {
    this.loading = Boolean(value);
  };

  setPage = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1) return;
    this.page = n;
  };

  setPageSize = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1) return;
    this.pageSize = n;
    this.page = 1;
  };

  reset = () => {
    this.rows = [];
    this.total = 0;
    this.totalPages = 0;
    this.page = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.sort = { ...DEFAULT_SORT };
    this.loading = false;
    this.hasLoadedOnce = false;
  };
}

export const dashboardEsgDataTableStore = new DashboardEsgDataTableStore();
